import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { CategorySortField, SortingOrder } from "@/graphql/codegen/graphql"
import ProductCategoriesContainer from "@/screens/ManageProducts/components/ProductCategories/containers/ProductCategoriesContainer"

const SearchParamsValidator = z.object({
  field: fallback(z.nativeEnum(CategorySortField), CategorySortField.Name),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
})

export const Route = createFileRoute("/app/admin/manage-products/_layout/categories")({
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams(["field", "order"])],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.PRODUCT_MAINTENANCE]}>
      <ProductCategoriesContainer />
    </PermissionContentWrapper>
  ),
})
